"use client"

import { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { ArrowUpIcon } from "lucide-react"

export function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 400)
        }
        window.addEventListener("scroll", toggleVisibility, { passive: true })
        return () => window.removeEventListener("scroll", toggleVisibility)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.button
                    initial={{ opacity: 0, y: 20, scale: 0.8 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 20, scale: 0.8 }}
                    transition={{ type: "spring", damping: 25, stiffness: 300 }}
                    onClick={scrollToTop}
                    className="fixed bottom-6 left-6 z-40 w-10 h-10 rounded-lg bg-muted/80 backdrop-blur-sm border border-border text-muted-foreground hover:text-primary hover:bg-muted transition-colors shadow-lg flex items-center justify-center"
                    aria-label="Voltar ao topo"
                >
                    <ArrowUpIcon className="h-4 w-4" />
                </motion.button>
            )}
        </AnimatePresence>
    )
}